"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectDataTable = exports.selectDataTable = function selectDataTable(table) {
  return function (state) {
    return state.datatable[table];
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-data-components/lib/selectors.js
// module id = 290
// module chunks = 0